import React from 'react';
import { Field } from 'redux-form';
import { renderCheckBox, renderTextField } from '../../../../components/reduxFields';
import { showFormatedDate, showFormattedTime, showNormalizedRate, SOAR, HYPERIONCENTER, HELPINGHANDS, FUTURES, TFABA, VIP, CWO } from '../../../../actions/utilAction';
import SubString from 'add-ellipsis';
import SortingCustom from '../../../../components/SortingCustom';
import { stylescss } from './ReadyToBill';
import './EvvReadyToBill.css';


export default class InnerDataTableColumn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data:props.data
    }
  }

  componentDidUpdate(prevProps){
    if(this.props.data && this.props.data !== prevProps.data){
      this.setState({
        data:this.props.data
      })
    }
  }

  setSortInnerColumn = (col_name, col_order,index) => {
    if (col_name) {
      let dataCopy = [...this.state.data];
      let claimServiceLines = [...this.state.data[index].claimServiceLines];
      let sortedArry = [];
      if(col_order == "asc"){
        sortedArry = claimServiceLines.sort(
          (a,b)=>{
            return new Date(a.serviceLineDOS) - new Date(b.serviceLineDOS)
          });
      }else if(col_order == "desc"){
        sortedArry = claimServiceLines.sort(
          (a,b)=>
          {
            return new Date(b.serviceLineDOS) - new Date(a.serviceLineDOS)
          });
      }

      dataCopy[index].claimServiceLines = sortedArry;
      this.setState({
        data:dataCopy
      })
    }
  };


  renderInnerData(data){
    return data.claimServiceLines.map((innerData, index) => {
      return <tr key={innerData.id}>
        <td width="12%">{innerData.serviceCode ? innerData.serviceCode : '-'}</td>
        <td width="8%">{innerData.serviceLineDOS ? showFormatedDate(innerData.serviceLineDOS) : ''}</td>
        <td width="8%">{innerData.modifier1 ? innerData.modifier1 : ''}
          {innerData.modifier2 ? ', ' + innerData.modifier2 : ''}
          {innerData.modifier3 ? ', ' + innerData.modifier3 : ''}
          {innerData.modifier4 ? ', ' + innerData.modifier4 : ''}</td>
        <td width="4%">{innerData.quantity || '-'}</td>
        <td width="5%">{showNormalizedRate(innerData.rate || 0)}</td>
        <td width="8%">{showNormalizedRate(innerData.totalAmount || 0)}</td>
        <td width="9%">{innerData.serviceFacilityCode}</td>
        <td width="12%">
          {data.isTricare ? this.props.editClaimServiceLineId === innerData.id || !innerData.claimLineNotesForTricare ? <Field name={`ClaimServiceLine[${innerData.id}].claimLineNotesForTricare`} type="text" maxLength="500" value={innerData.claimLineNotesForTricare} hintText={'Line Note'} onBlur={e => this.props.updateClaimLineNotesForTricare(e, data.claimId, innerData.id)} component={renderTextField} /> : <span onDoubleClick={e => this.props.handleEditClaimLineNotesForTricare(e, innerData.id, innerData.claimLineNotesForTricare)}>
            {innerData.claimLineNotesForTricare}
          </span> : null}
        </td>
        {this.props.agencyName.toUpperCase() === 'DEMO' || this.props.agencyName.toUpperCase() === VIP ? <td width="13%">{innerData.staffNames}</td> : <td width="13%">{innerData.isMultiplePractitioner ? innerData.staffNames : innerData.clinician}</td>}
        <td width="11%">{innerData.renderingProvider || '-'}</td>
        {this.props.updateServiceCodePermission || this.props.deleteServiceCodePermission ? <td width="9%">
          {this.props.updateServiceCodePermission ? <button onClick={e => this.props.handleEditServiceCodeClick(e, innerData, data.patientId, data.patientInsuranceId, data.payerId)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button> : null}
          {this.props.agencyName.toUpperCase() === CWO && this.props.deleteServiceCodePermission ? <button onClick={e => this.props.handleDeleteClick(e, innerData)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button> : null}
        </td> : null}
      </tr>;
    })
  }


  render() {
    return (
      <tbody>

        {this.state.data.map((data, index) => {
          return <tr key={data.claimId}>
            <td colSpan="10">
              <table className={this.props.tableClass1}>
                <tbody>
                  <tr>
                    <td width="10%">
                      <div className="table_custom-check">
                        <Field name={`Claims[${index}].Chk`} component={renderCheckBox} onChange={e => this.props.CheckClaim(e, index, data)} style={stylescss.checkbox} />
                        <button onClick={e => this.props.handleExpandRow(data.claimId)} type="button" className="morebtn">
                          <i ref={'expClass' + data.claimId} className="classExpand fa fa-minus" aria-hidden="true"></i>
                        </button>

                      </div>
                    </td>
                    <td width="13%">
                      <div className="claim" onClick={e => this.props.openDialog(e, data.claimId)}>
                        {'CL' + data.claimId}
                        {this.props.viewSoapPermission ? <i className="fa fa-info-circle infoIcon" aria-hidden="true" title="Click here to view Session Note"></i> : null}
                        <div className={this.props.clicked && this.props.claimIdShowHide === data.claimId ? 'claimbox show' : 'claimbox hide'}>
                          <div className="claimheader">
                            <h3>Claim ID : <span>{'CL' + data.claimId}</span></h3>
                            <div className="claimicons">
                              <ul>
                                <li><a title="close" href=""><i className="fa fa-times"></i></a></li>
                              </ul>
                            </div>
                          </div>
                          <div className="claimcontent">
                            {
                              /* <div className="claimdosdate">
                                                         <i className="fa fa-calendar bluefont" aria-hidden="true"></i> Date of Service : <span>{showFormatedDate(data.dos)}</span>
                                                       </div>*/
                            }
                            <h3>{data.renderingProvider}</h3>
                            <div className="claimsoapdate">
                              <ul>
                                {data.claimEncounters.map((encounterData, index) => {
                                  return <li key={encounterData.patientEncounterId}>
                                    <i className="fa fa-clock-o bluefont" aria-hidden="true"></i>
                                    <span>{showFormattedTime(encounterData.startDateTime)}</span> - <span>{showFormattedTime(encounterData.endDateTime)}</span>
                                    {this.props.agencyName.toUpperCase() !== SOAR && this.props.agencyName.toUpperCase() !== HYPERIONCENTER && this.props.agencyName.toUpperCase() !== HELPINGHANDS && this.props.agencyName.toUpperCase() !== FUTURES && this.props.agencyName.toUpperCase() !== TFABA ? <i onClick={() => this.props.GetPatientEncounterDetails(encounterData.patientAppointmentId, encounterData.patientEncounterId)} className="fa fa-info-circle infoIcon" aria-hidden="true" title="Click here to view session note"></i> : null}
                                  </li>;
                                })}
                              </ul>
                            </div>
                          </div>
                        </div>
                        {data.errorMessages ? (
                          <div className="errorMessages">
                            <i className="fa fa-exclamation-triangle" style={{ color: 'red' }} aria-hidden="true"></i>
                            <div className="errorTooltip">
                              <ol>
                                {data.errorMessages.split(',').map((errorMessage, index) => (
                                  <li key={index}>{errorMessage.trim()}</li>
                                ))}
                              </ol>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </td>
                    {/* <td width="10%">{showFormatedDate("01/01/1990") === showFormatedDate(data.dos) ? "" : showFormatedDate(data.dos)}</td> */}
                    <td width="16%">{data.dosForGroupClaims}</td>
                    <td width="15%">{data.patientName}</td>
                    {
                      /* <td width="15%">{data.clinician}</td>
                      <td width="13%">{data.renderingProvider}</td> */
                    }
                    <td width="13%">{data.authorizationNumber}</td>
                    <td width="14%">{data.payer != null && data.payer.length > 15 ? SubString(data.payer, 15) : data.payer != null ? data.payer : 'N/A'}</td>
                    <td width="14%">
                      {this.props.editClaimId === data.claimId || !data.additionalClaimInfo ? <Field name={`Claims[${index}].additionalClaimInfo`} type="text" maxLength="60" value={data.additionalClaimInfo} hintText={'Additional Information'} // onChange={(e) => this.handleChange(e, data.claimId, index)}
                        onBlur={e => this.props.updateAdditionalInfo(e, data.claimId, index)} component={renderTextField} /> : <span onDoubleClick={e => this.props.handleEdit(e, data.claimId, index, data.additionalClaimInfo)}>
                        {data.additionalClaimInfo}
                      </span>}
                    </td>
                    <td width="10%">{showNormalizedRate(data.totalAmount || 0)}</td>

                    {this.props.submitClaimPermission || this.props.addServiceCodePermission ? <td width="10%">
                      {
                        /* {
                         this.props.submitClaimPermission ?
                           <button onClick={(e) => this.handleOnSubmit(e, data)} type="button" title="Submit" className="tbactionbtn bluefont"><i className="fa fa-paper-plane" aria-hidden="true"></i></button>
                           : null
                        } */
                      }
                      {
                        /* {
                         this.props.updateClaimPermission ?
                           <button onClick={(e) => this.handleEditClaimClick(e, data)} type="button" title="Edit Claim" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                           : null
                        } */
                      }
                      {this.props.addServiceCodePermission ? <button onClick={e => this.props.handleOpen(e, data)} type="button" title="Add New Service Code" className="tbactionbtn redfont"><i className="fa fa-plus-square" aria-hidden="true"></i></button> : null}
                      {
                        /* {
                         this.props.deleteClaimPermission ?
                           <button onClick={(e) => this.handleDeleteClaimClick(e, data)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                           : null
                        } */
                      }
                      <button onClick={e => this.props.handleOpenHistory(e, data.claimId)} type="button" title="Claim History" className="tbactionbtn bluefont"><i className="fa fa-history" aria-hidden="true"></i></button>
                      <button onClick={e => this.props.handleOpenInternalNotes(e, data)} type="button" title="Claim Internal Notes" className="tbactionbtn bluefont"><i className="fa fa-sticky-note-o" aria-hidden="true"></i></button>
                    </td> : null}
                  </tr>
                  <tr className="nohover" ref={'expandedClass' + data.claimId} style={{
                    'display': 'table-row'
                  }}>
                    <td></td>
                    <td colSpan="9">
                      <table className={this.props.tableClass2}>
                        <thead>
                          <tr>
                            <th width="12%">Service Code</th>
                            <th width="8%">DOS</th>
                            <th width="8%">Modifiers</th>
                            <th width="4%">Unit</th>
                            <th width="5%">Rate($)</th>
                            <th width="8%">Amount($)</th>
                            <th width="9%">Loc. Code</th>
                            <th width="12%">{data.isTricare ? 'Line Note' : ''}</th>
                            <th width="13%">Practitioner</th>
                            <th width="11%">Rend. Provider</th>
                            {this.props.updateServiceCodePermission || this.props.deleteServiceCodePermission ? <th width="9%">Action</th> : null}
                          </tr>
                        </thead>
                        <tbody>
                          {this.renderInnerData(data)}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>;
        })}
      </tbody>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/InnerDataTableColumn.js